// export const arbeidsOptionsFarger = {
//   broyting: '#0071bb',
//   spreder: '#d32316',
//   broytingOgSpreder: '#f29f04',
//   renhold: '#22b473',
//   tomkjoring: '#4d4d4d',
//   snofresing: '#fff',
//   stroing: '#34d5eb', // midlertidig
//   kantklipping: '#a80092', // midlertidig
//   ukjent: '#000',
// };

// export const arbeidOptionsIds = {
//   broyting: '0',
//   salting: '1', // ?? samme som spreder?
//   spreder: '2',
//   broytingOgSpreder: '0,2',
//   renhold: '3',
//   snofresing: '4',
//   stroing: '8',
//   kantklipping: '10',
//   tomkjoring: null,
// };

export const utstyrsloggNavnKeys = {
  ukjent: 'utstyrlogg.ukjent',
  tomkjoring: 'utstyrlogg.tomkjoring',
  broytingOgSpreder: 'utstyrlogg.broytingOgSpreder',
  broyting: 'utstyrlogg.broyting',
  salting: 'utstyrlogg.salting',
  spreder: 'utstyrlogg.spreder',
  renhold: 'utstyrlogg.renhold',
  stroing: 'utstyrlogg.stroing',
  kantklipping: 'utstyrlogg.kantklipping',
  snofresing: 'utstyrlogg.snofresing',
};

export const seksjonNavnKeys = {
  vei: 'seksjon.vei',
};

// export const getUtsyrsloggNavnKey = (id) => {
//   if (id === null) return utstyrsloggNavnKeys.tomkjoring;

//   const utstyrArray =
//     id !== null ? id.split(',').map((item) => item.trim()) : [];

//   if (
//     utstyrArray.includes(arbeidOptionsIds.broyting) &&
//     utstyrArray.includes(arbeidOptionsIds.spreder)
//   ) {
//     return utstyrsloggNavnKeys.broytingOgSpreder;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.broyting)) {
//     return utstyrsloggNavnKeys.broyting;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.salting)) {
//     return utstyrsloggNavnKeys.salting;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.spreder)) {
//     return utstyrsloggNavnKeys.spreder;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.renhold)) {
//     return utstyrsloggNavnKeys.renhold;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.snofresing)) {
//     return utstyrsloggNavnKeys.snofresing;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.stroing)) {
//     return utstyrsloggNavnKeys.stroing;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.kantklipping)) {
//     return utstyrsloggNavnKeys.kantklipping;
//   }

//   return utstyrsloggNavnKeys.ukjent;
// };

// rename etter utfasing av gammal drit
export const arbeidstyper = {
  ukjent: -1,
  broyting: 0,
  salting: 1,
  broytingOgSalting: 2,
  broytingOgGrusing: 3,
  grusstroing: 4,
  snofresing: 5,
  etterrydding: 6,

  renhold: 10,
  kantklipping: 15,

  tomkjoring: null,
};

export const getTranslateKeyForArbeidstype = (arbeidstypeId) => {
  switch (arbeidstypeId) {
    case arbeidstyper.ukjent:
      return 'utstyrlogg.ukjent';
    case arbeidstyper.broyting:
      return 'utstyrlogg.broyting';
    case arbeidstyper.salting:
      return 'utstyrlogg.salting';
    case arbeidstyper.broytingOgSalting:
      return 'utstyrlogg.broytingOgSpreder';
    case arbeidstyper.broytingOgGrusing:
      return 'utstyrlogg.broytingOgGrusing';
    case arbeidstyper.grusstroing:
      return 'utstyrlogg.stroing';
    case arbeidstyper.snofresing:
      return 'utstyrlogg.snofresing';
    case arbeidstyper.etterrydding:
      return 'utstyrlogg.etterrydding';
    case arbeidstyper.renhold:
      return 'utstyrlogg.renhold';
    case arbeidstyper.kantklipping:
      return 'utstyrlogg.kantklipping';
    case arbeidstyper.tomkjoring:
      return 'utstyrlogg.tomkjoring';
    default:
      return 'utstyrlogg.ukjent';
  }
};

export const getTranslateKeyForUtstyrslogg = (utstyrsloggId) => {
  const utstyrsnavn = utstyrsloggId?.split(',').map((item) => {
    return mapUtstyrIdtToUtstyrnavn(item.trim());
  });

  return utstyrsnavn?.join(', ');
};

export const mapUtstyrIdtToUtstyrnavn = (utstyrsloggId) => {
  switch (utstyrsloggId) {
    case null:
      return '';
    case '0':
      return `Brøyting (${utstyrsloggId})`;
    case '1':
      return `Brøyting og salting (${utstyrsloggId})`;
    case '2':
      return `Spreder (${utstyrsloggId})`;
    case '3':
      return `Renhold (${utstyrsloggId})`;
    case '4':
      return `Snøfresing (${utstyrsloggId})`;
    default:
      return `Ukjent (${utstyrsloggId})`;
  }
};

export const getSporfarge2 = (tiltakId) => {
  // console.log('getSporfarge2 tiltakId=', tiltakId);

  const tiltaksfarger = {
    [arbeidstyper.ukjent]: '#000',
    [arbeidstyper.broyting]: '#0071bb',
    [arbeidstyper.salting]: '#d32316',
    [arbeidstyper.broytingOgSalting]: '#f29f04',
    [arbeidstyper.broytingOgGrusing]: '#008917ff',
    [arbeidstyper.grusstroing]: '#34d5eb',
    [arbeidstyper.snofresing]: '#ec6733ff',
    [arbeidstyper.etterrydding]: '#ff14b9ff',

    [arbeidstyper.renhold]: '#22b473',

    [arbeidstyper.kantklipping]: '#005828ff',
    [arbeidstyper.tomkjoring]: '#707070ff',
  };

  // const tiltaksfarger2 = {
  //   0: '#000', // ukjent
  //   1: '#0071bb', // brøyting
  //   2: '#d32316', // salting
  //   3: '#f29f04', // brøying og salting
  //   4: '#22b473', // renhold
  //   5: '#fff', // snøfresing
  //   6: '#34d5eb', // grusstrøing
  //   7: '#a80092', // kantklipping
  //   null: '#808080ff', // tomkjøring
  // };

  return tiltaksfarger[tiltakId];
};

// export const getSporFarge = (utstyrlogg) => {
//   if (utstyrlogg === null) return arbeidsOptionsFarger.tomkjoring;
//   const utstyrArray =
//     utstyrlogg != null ? utstyrlogg.split(',').map((item) => item.trim()) : [];

//   if (
//     utstyrArray.includes(arbeidOptionsIds.broyting) &&
//     utstyrArray.includes(arbeidOptionsIds.spreder)
//   ) {
//     return arbeidsOptionsFarger.broytingOgSpreder;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.broyting)) {
//     return arbeidsOptionsFarger.broyting;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.spreder)) {
//     return arbeidsOptionsFarger.spreder;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.renhold)) {
//     return arbeidsOptionsFarger.renhold;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.snofresing)) {
//     return arbeidsOptionsFarger.snofresing;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.stroing)) {
//     return arbeidsOptionsFarger.stroing;
//   }
//   if (utstyrArray.includes(arbeidOptionsIds.kantklipping)) {
//     return arbeidsOptionsFarger.kantklipping;
//   }
//   return arbeidsOptionsFarger.ukjent;
// };

export const arbeidOptions = [
  {
    label: 'Brøyting',
    labelKey: getTranslateKeyForArbeidstype(arbeidstyper.broyting),
    value: false,
    legendClassName: 'arbeid broyting',
    filterKeys: 0,
    color: getSporfarge2(arbeidstyper.broyting),
  },
  {
    label: 'Spreder', // salting
    labelKey: getTranslateKeyForArbeidstype(arbeidstyper.salting),
    value: false,
    legendClassName: 'arbeid spreder',
    filterKeys: 1,
    color: getSporfarge2(arbeidstyper.salting),
  },
  {
    label: 'Brøyting og spreder',
    labelKey: getTranslateKeyForArbeidstype(arbeidstyper.broytingOgSalting),
    value: false,
    legendClassName: 'arbeid broyting-og-spreder',
    filterKeys: 2,
    color: getSporfarge2(arbeidstyper.broytingOgSalting),
  },
  {
    label: 'Brøyting og grusing',
    labelKey: getTranslateKeyForArbeidstype(arbeidstyper.broytingOgGrusing),
    value: false,
    legendClassName: 'arbeid broyting-og-grusing',
    filterKeys: 3,
    color: getSporfarge2(arbeidstyper.broytingOgGrusing),
  },
  {
    label: 'Strøing', // grusstrøing
    labelKey: utstyrsloggNavnKeys.stroing,
    value: false,
    legendClassName: 'arbeid stroing',
    filterKeys: 4,
    color: getSporfarge2(arbeidstyper.grusstroing),
  },
  {
    label: 'Snøfresing',
    labelKey: utstyrsloggNavnKeys.snofresing,
    value: false,
    legendClassName: 'arbeid snofresing',
    filterKeys: 5,
    color: getSporfarge2(arbeidstyper.snofresing),
  },
  {
    label: 'Etterrydding',
    labelKey: utstyrsloggNavnKeys.etterrydding,
    value: false,
    legendClassName: 'arbeid etterrydding',
    filterKeys: 6,
    color: getSporfarge2(arbeidstyper.etterrydding),
  },
  {
    label: 'Renhold',
    labelKey: utstyrsloggNavnKeys.renhold,
    value: false,
    legendClassName: 'arbeid renhold',
    filterKeys: 10,
    color: getSporfarge2(arbeidstyper.renhold),
  },
  {
    label: 'Kantklipping',
    labelKey: utstyrsloggNavnKeys.kantklipping,
    value: false,
    legendClassName: 'arbeid kantklipping',
    filterKeys: 15,
    color: getSporfarge2(arbeidstyper.kantklipping),
  },
  {
    label: 'Tomkjøring',
    labelKey: utstyrsloggNavnKeys.tomkjoring,
    value: false,
    legendClassName: 'arbeid tomkjoring',
    filterKeys: null,
    color: getSporfarge2(arbeidstyper.tomkjoring),
  },
];

export const seksjonOptions = [
  { label: 'Vei', labelKey: seksjonNavnKeys.vei, value: false },
];
